import {useEffect} from "react";
import {useFormikContext} from "formik";
import {NEW_RESIDENT, FetchStatusReturnType} from "../SimilarResidents/types";
import {FormValues} from "./types";

export const useHandleSimilarResidents = (fetching: FetchStatusReturnType) => {
  const {setFieldValue, initialValues} = useFormikContext<FormValues>();

  const {similarResidentsFound, similarResidents, isFetchingSimilarResidents} =
    fetching;

  const setSimilarResidentField = (residentId: string): void => {
    setFieldValue("resident_demographics.similar_resident", residentId);
  };

  const setToNewResident = (): void => {
    setSimilarResidentField(NEW_RESIDENT);
  };

  const setToExistingResident = (residentId: string): void => {
    setSimilarResidentField(residentId);
  };

  useEffect(() => {
    const initialSimilarResident =
      initialValues?.resident_demographics?.similar_resident;

    if (!similarResidentsFound || !initialSimilarResident) {
      return;
    }

    const perfectMatch = similarResidents.find(
      resident => resident.match === "100%",
    );

    if (perfectMatch) {
      setToExistingResident(perfectMatch.resident.id);
      return;
    }

    const currentResidentExists = similarResidents.some(
      similarResident => similarResident.resident.id === initialSimilarResident,
    );

    if (currentResidentExists) {
      setToExistingResident(initialSimilarResident);
    } else {
      setToNewResident();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isFetchingSimilarResidents,
    similarResidentsFound,
    similarResidents,
    initialValues?.resident_demographics?.similar_resident,
  ]);
};
